// eslint-disable-next-line no-restricted-imports
import { useCallback } from 'react'
import { useTranslation as useTranslationCore } from 'react-i18next'

// eslint-disable-next-line no-restricted-imports
export { Trans } from 'react-i18next'

type TFunctionDangerResult = {
  dangerouslySetInnerHTML: {
    __html: string
  }
}

type ExtendReturnType<T extends (...a: any) => any, TExtend> = (...a: Parameters<T>) => ReturnType<T> & TExtend
type ChangeReturnType<T extends (...a: any) => any, TChange> = (...a: Parameters<T>) => TChange

type TDangerFunc = ChangeReturnType<ReturnType<typeof useTranslationCore>['t'], TFunctionDangerResult>
type UseTranslationWithDanger = ExtendReturnType<typeof useTranslationCore, { tDanger: TDangerFunc }>

export const useTranslation: UseTranslationWithDanger = (...props) => {
  const base = useTranslationCore(...props) as ReturnType<UseTranslationWithDanger>

  base.tDanger = useCallback<TDangerFunc>((...args) => ({
    dangerouslySetInnerHTML: {
      __html: base.t(...args),
    },
  }), [base])

  return base
}
